<script>
import chatLog from "../components/chatLog";

export default {
  name: "chat",
  components: {
    chatLog,
  },
  props: {
    refreshChat: Number,
    inlineChat: Boolean,
    generalOnly: Boolean,
  },
  data: function() {
    return {
      message: "",
      refreshLogUser: 0,
    };
  },
  methods: {
    async onSendMessage() {
      var self = this;
      if (this.message) {
        var newMessage = {
          auctionId: this.auctionId,
          bidId: this.activeBidId,
          content: this.message,
        };
        var confirmSend = true;
        if (!this.activeVesselName) {
          confirmSend = confirm("This message will be sent to all bidders.  Are you sure you wish to proceed?");
        }
        if (confirmSend) {
          var success = await this.$store.dispatch("postRequest", { controller: "chat", method: "create", parameters: newMessage });
          if (success) {
            self.refreshLogUser++;
            self.message = "";
          }
        }
      }
    },
  },
  computed: {
    auctionId: function() {
      return this.$store.state.activeAuction.id;
    },
    activeVesselName: function() {
      return this.$store.state.activeVesselName || null;
    },
    hasAuctionFinished: function() {
      return this.$store.state.activeAuction.status == "Complete";
    },
    userRole: function() {
      return this.$store.state.role;
    },
    canSendToAll: function() {
      return this.userRole == "ADM" || this.userRole == "CHA" || this.userRole == "SHP" || this.userRole == "ANA";
    },
    activeBidId: function() {
      if (this.generalOnly) {
        return null;
      } else {
        return this.$store.state.activeBid ? this.$store.state.activeBid.offerId : null;
      }
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  mounted: function() {},
};
</script>
<template>
  <div class="chat-wrapper content-bordered" v-if="auctionId" v-on:click.stop="" :class="[inlineChat ? 'inline-chat' : '']">
    <chat-log :refreshLogUser="refreshLogUser" :refreshLogRemote="refreshChat" :generalOnly="generalOnly" :inlineChat="inlineChat"></chat-log>
    <div id="chat-input-wrapper">
      <div class="content-bordered message-input-wrapper">
        <textarea
          v-if="!(isMobile && inlineChat)"
          :disabled="hasAuctionFinished"
          v-model="message"
          :placeholder="isMobile ? 'Type your message here...' : activeVesselName && userRole != 'OWN' ? `Conversation with ${activeVesselName}...` : `Type your message here...`"
          v-on:keyup.enter="onSendMessage()"
        ></textarea>
        <input
          v-else
          style="border-bottom:1px solid #ced4da !important"
          :disabled="hasAuctionFinished"
          v-model="message"
          :placeholder="inlineChat ? 'Type your message here...' : activeVesselName && userRole != 'OWN' ? `Conversation with ${activeVesselName}...` : `Type your message here...`"
          v-on:keyup.enter="onSendMessage()"
        />
      </div>
      <div class="content-bordered message-send-button-wrapper" v-if="!(isMobile && inlineChat)">
        <button :disabled="hasAuctionFinished" type="button" class="btn btn-light" v-on:click="onSendMessage()"><span v-if="canSendToAll && !activeBidId">Send to All</span><span v-else-if="!inlineChat">Send</span><i :class="[inlineChat ? '' : 'icon-right']" class="fas fa-paper-plane"></i></button>
      </div>
    </div>
  </div>
</template>
<style>
.chat-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
#chat-input-wrapper {
  height: 100px;
  bottom: 0px;
  position: absolute;
  width: 100%;
}
.inline-chat #chat-input-wrapper {
  height: 25px;
  padding-left: 4.8px;
  padding-right: 4.8px;
  bottom: 4.8px;
}
#chat-input-wrapper > div {
  height: 100%;
  border-radius: 0px;
}
textarea {
  width: 100%;
  height: 100%;
  border: none;
  resize: none;
  outline: none;
}
input {
  width: 100%;
  border: none;
  resize: none;
  outline: none;
}

.message-send-button-wrapper {
  width: 100px;
  float: right;
}
.inline-chat .message-send-button-wrapper {
  width: 50px;
  font-size: 12px;
}
.message-send-button-wrapper > button {
  width: 100%;
  height: 100%;
}
.message-input-wrapper {
  width: calc(100% - 100px);
  display: inline-block;
}
.inline-chat .message-input-wrapper {
  width: 100%;
}
</style>
